import { PageWrapper, STATUSPAGE } from '@repo/ui';
import { Card, CardBody, Spinner } from 'reactstrap';

import { PendingActivitiesFiltersForm } from '../../components/pending-activities-filters-form';
import { PendingActivitiesPagination } from '../../components/pending-activities-pagination';
import { PendingActivitiesProfessionalAccordion } from '../../components/pending-activities-professional-accordion';
import { PendingActivitiesSummary } from '../../components/pending-activities-summary';
import { usePendingActivitiesReport } from '../../hooks/usePendingActivitiesReport';

export const PendingActivitiesReport = () => {
  const {
    isManager,
    validation,
    statusGet,
    statusGetSummary,
    statusExport,
    organizations,
    courses,
    semesters,
    curricularUnits,
    groups,
    professionals,
    handleExport,
    kpiSource,
    dataSource,
    hasDataSource,
    totalItems,
    selectedPage,
    totalPages,
    pages,
    rowsPerPage,
    handlePageChange,
    handleRowsPerPageChange,
  } = usePendingActivitiesReport();

  return (
    <PageWrapper title="Atividades Pendentes por Profissional">
      <div className="d-flex flex-wrap align-items-start justify-content-between gap-2 mb-3">
        <div>
          <h4 className="mb-1">Atividades Pendentes por Profissional</h4>
          <p className="text-muted mb-0">
            Visualize as atividades exclusivas e compartilhadas pendentes por
            profissional no período selecionado
          </p>
        </div>
      </div>

      <Card>
        <CardBody>
          <PendingActivitiesFiltersForm
            isManager={isManager}
            validation={validation}
            organizations={organizations}
            courses={courses}
            semesters={semesters}
            curricularUnits={curricularUnits}
            groups={groups}
            professionals={professionals}
            statusGet={statusGet}
            statusExport={statusExport}
            onExport={handleExport}
          />
        </CardBody>
      </Card>

      <PendingActivitiesSummary
        professionals={kpiSource.professionals}
        pendingActivities={kpiSource.pendingActivities}
        exclusive={Number(kpiSource?.exclusive)}
        shared={Number(kpiSource?.shared)}
        loading={statusGetSummary === STATUSPAGE.LOADING}
      />

      <Card className="mt-3">
        <CardBody>
          {statusGet === STATUSPAGE.LOADING ? (
            <div className="text-center py-4">
              <Spinner />
            </div>
          ) : hasDataSource ? (
            <>
              <PendingActivitiesProfessionalAccordion
                items={dataSource?.data || []}
              />

              <PendingActivitiesPagination
                totalItems={totalItems}
                selectedPage={selectedPage}
                totalPages={totalPages}
                pages={pages}
                rowsPerPage={rowsPerPage}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
              />
            </>
          ) : (
            <div className="text-center py-4 text-muted">
              Nenhum registro encontrado para os filtros selecionados.
            </div>
          )}
        </CardBody>
      </Card>
    </PageWrapper>
  );
};
